import {AvailabilityStateSlice} from '../slices/AvailabilityStateSlice';

export const availabilitiesErrorOccured = (
  state: AvailabilityStateSlice,
  action: {payload: {description: string}},
): void => {
  state.error = action.payload;
};

export const availabilitiesErrorDismissed = (state: AvailabilityStateSlice): void => {
  state.error = undefined;
};
